export default __webpack_public_path__ + "static/media/ad-2.cb7fd3e1.jpg";